import { render, staticRenderFns } from "./CampaignOptionPanel.vue?vue&type=template&id=4b08957e&"
import script from "./CampaignOptionPanel.vue?vue&type=script&lang=ts&"
export * from "./CampaignOptionPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports